module.exports = __webpack_public_path__ + "img/magento.c81b0b25.svg";